module.exports = __webpack_public_path__ + "static/blue_dragon-8c4f968d3e70af54d8ebbcd29a03b852.jpg";